.label-field-container {
    width: 100%;
    min-width: 150px;
    margin-left: -4px;
}
